//imgcache path
//国际化的支持
import { i18n } from '../../loader/i18n/i18n';
import appUtils from '../lib/appUtil';


let NeedLangMap = {};
//获取当前平台
function getPlatform() {
  if (window.QCIMGCACHE_HOST) {
    //租户端
    return 'tcloud';
  } else if (window.TCE_DOMAIN) {
    return 'ocloud';
  }
}

var imgcacheUrl = appUtils.getImgcacheUrl();

let CONFIG = {
  REACT_BUNDLE: [
    imgcacheUrl + '/common/js/react/polyfill.min.js',
    imgcacheUrl + '/common/js/react/react-with-addons.min.js'
  ],
  bundles16: [
    imgcacheUrl + '/common/js/react/polyfill.min.js',
    imgcacheUrl + '/common/js/react/react-with-addons.min.js',
    imgcacheUrl + '/common/js/moment/moment-2.24.0',
    imgcacheUrl + '/common/js/react/react16.development.js'
  ],
  reati18next: [
    imgcacheUrl + "/common/js/i18next/i18next-lib-16.js"
  ],
  tea2comopnent: [
    imgcacheUrl + '/common/js/tea2/tea-component-v2.2.2.4.js',
    // tea.css部分会影响到购买页面组件库,使用buy.css，后期样式问题，购买页同事处理
    //由于购买页加载了buy.css包含tea.css样式，是重构组单独提供。  
    //imgcacheUrl + '/common/css/tea2/tea-v2.2.2.4.min.css'
  ],
  ANTD_APP_BUNDLE: [
    imgcacheUrl + '/common/js/antd/babel-polyfill.js',
    imgcacheUrl + '/common/js/antd/react-with-addons.js',
    imgcacheUrl + '/common/js/antd/react-dom.js',
    imgcacheUrl + '/common/js/antd/antd.js'
  ]
};

var lang = window.VERSION;
var TEA_APP_BUNDLE_MAP = {
  zh: imgcacheUrl + '/common/js/tea/tea.js'
};

var TEA_APP_BUNDLE = TEA_APP_BUNDLE_MAP[lang] || TEA_APP_BUNDLE_MAP['zh'];

var loadBundle = function (bundle, cb) {
  seajs.use(bundle, function () {
    setTimeout(cb, 1);
  });
};

let reactsupport = {
  isReactAppSource: function (jsSrc) {
    return /#rx-app/.test(jsSrc);
  },
  isLteIE9: function (jsSrc) {
    return /#rx-app-lteie9/.test(jsSrc);
  },

  isTeaApp: function (jsSrc) {
    return /#rx-app-tea$/.test(jsSrc);
  },

  isTea2App: function (jsSrc) {
    return /#rx-app-tea2/.test(jsSrc);
  },

  isAntdApp: function (jsSrc) {
    return /#rx-app-antd/.test(jsSrc);
  },

  useReact: function (cb) {
    loadBundle(CONFIG.REACT_BUNDLE, cb);
  },

  useTea: function (cb) {
    this.useReact(function () {
      loadBundle(TEA_APP_BUNDLE, cb);
    });
  },

  //动态加载CSS
  setCssGolbal: function (href) {
    var cssLink = $('head').find('link[rel="stylesheet"]');
    cssLink.each(function (i, link) {
      if (link && link.href && link.href.match(href)) {
        $(link)
          .attr('data-role', 'global')
          .removeAttr('disabled');
      }
    });
  },

  //非tea2禁止加载CSS
  disableSetCssGolbal: function (href) {
    var cssLink = $('head').find('link[rel="stylesheet"]');
    cssLink.each(function (i, link) {
      if (link && link.href && link.href.match(href)) {
        $(link).attr('disabled', true);
      }
    });
  },
  useTea2: function (cb) {
    let self = this;
    loadBundle(CONFIG.bundles16, () => {
      loadBundle(CONFIG.reati18next, () => {
        loadBundle(CONFIG.tea2comopnent, () => {
          reactsupport.setCssGolbal(/tea-.*.min.css$/);
          cb && cb();
        });
      });
    });
  },

  useTeaAntd: function (cb) {
    loadBundle(CONFIG.ANTD_APP_BUNDLE, cb);
  },

  //加载语言
  loadI18nResource: function (jsSrc, loadBusJs) {
    var Language = i18n.getLoadLangName();
    var langPath = getI18nResourcePathSwitchMap(jsSrc, Language);
    i18n &&
      i18n.init({
        targetModule: null,
        backend: {
          loadPath: langPath,
          allowMultiLoading: true,
          // allow cross domain requests
          crossDomain: true,
          // allow credentials on cross domain requests
          withCredentials: true,
          ajax: function (url, options, callback, data) {
            //默认不加载语言
            if (i18n.getLanguage() === 'zh' || i18n.getLanguage() === 'zh-CN') {
              callback({}, { status: 200 });
            } else {
              seajs.use([url], (data) => {
                if (data && data.translation) {
                  try {
                    callback(data.translation, { status: 200 });
                  } catch (e) {
                    console.log("加载语言失败：" + e);
                    callback({}, { status: 200 });
                  }
                } else {
                  callback({}, { status: 200 });
                  console.log("无语言存在");
                }
              })

            }
          }
        },
        callback: function (lng) {
          loadBusJs();
        }
      });
  },
  loadFn: function (jsSrc, cb, name) {
    let use;
    let isAntdApp = this.isAntdApp(jsSrc);
    if (isAntdApp) {
      use = this.useTeaAntd;
    } else if (this.isTeaApp(jsSrc)) {
      //延迟执行，避免页面排版瞬间错乱
      //处理input:checkbox 样式覆盖
      setTimeout(function () {
        this.disableSetCssGolbal(/tea-.*.min.css$/);
      }, 1000);
      use = this.useTea;
    } else if (this.isTea2App(jsSrc)) {
      use = this.useTea2;
    } else {
      use = this.useReact;
    }
    use(function () {
      //是否需要加载语言包
      let isloadI18nResource = needloadI18nResource(name, jsSrc);//默认加载
      jsSrc = parsePath(jsSrc);
      //如果是tea2开发，优先加载语言
      if (reactsupport.isTea2App(jsSrc) && isloadI18nResource) {
        reactsupport.loadI18nResource(jsSrc, function () {
          seajs.use(jsSrc, cb);
        });
      } else {
        seajs.use(jsSrc, cb);
      }
    });
  }
};

export function getJsPath(jsrc) {
  jsrc = jsrc || "";
  return jsrc.substr(0, jsrc.lastIndexOf("/"));
}

//i18n资源路径转换
export function getI18nResourcePathSwitchMap(jSrc, Language) {
  let path = getJsPath(jSrc) + '/i18n/translation/' + Language + '.js';
  return path;
}

/**
  * 转换_lang_
  */
export function jsRouterFix() {
  let jsRouter = seajs.use("config/jsRouter");
  let i18n = seajs.use("i18n");
  if (jsRouter) {
    var Language = i18n.getLoadLangName();
    for (let item in jsRouter) {
      NeedLangMap[item] = jsRouter[item].lastIndexOf('_lang_.js') > 0 ? false : true;
      jsRouter[item] = jsRouter[item].replace("_lang_", Language);
    }
  }
}
/**
 * css转换_lang_
 */
export function cssConfigFix() {
  let cssConfig = window.seajs.use("config/css");
  let i18n = window.seajs.use("i18n");
  if (cssConfig) {
    var Language = i18n.getLoadLangName();
    for (let item in cssConfig) {
      for (let i = 0; i < cssConfig[item].length; ++i) {
        cssConfig[item][i] = cssConfig[item][i].replace("_lang_", Language);
      }
    }
  }
}

/**
  * 是否需要加载语言
  * 开发模式需要加载
  */
export function needloadI18nResource(name, jsSrc) {
  let ret = NeedLangMap[name] ? true : isDynamicPath(jsSrc);
  let isDev = (window.devmode && devmode.getStatus() == 'on') ? true : false;
  return ret ? ret : isDev;
}
export function isDynamicPath(path) {
  return path.match(/_lang_/) ? true : false;
}
/**
 * 解析jsSrc
 */
export function parsePath(path) {
  let Language = i18n.getLoadLangName();
  return path.replace("_lang_", Language);
}
export { reactsupport };
